import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}))
}
